/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in 
*                 part without express written permission of Honeywell Inc. 
*                 is prohibited.
*
* Name          : product-listing-api.ts
* 
* Project Title : Checkout
*  
* Description   : Initial version
* 
* Company       : Honeywell Technology Solutions , Hyderabad
* 
* @Author       : Madhu Gali - H175591
* 
* @Date         : Oct 07, 2019
*
* @Version      : Version 1.0
*
 * By            : Madhu Gali (H175591)
 * On            : Oct 04, 2019
 * Description   : ASDS-1476
 * 
 * By            : H224423
 * On            : Mar 26, 2020
 * Description   : Updated product service with sold to parameter.
 * 
******************************************************************************/
import API from './api';
import { CategoryListingAPIRes } from '../PurchaseSoftware/';
import { ProductListingParams } from '../../../../types';
import QueryString from 'query-string';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { handleResponse, handleError } from './apiUtils';

class ProductListing {

    static async getProductListing(params: ProductListingParams = {}): Promise<CategoryListingAPIRes> {
        let queryParams = "";
    
        if(params.soldTo){
            queryParams = `?search=${params.soldTo}&fields=soldTo`;
            if(params.categoryId || params.system){
                params.soldTo = undefined;
                queryParams = queryParams + `&${QueryString.stringify(params)}`;
            }
        }
        
        const productListingURL = CheckoutServiceURL.PRODUCT_LISTING_URL;
        let data = await API.get(`${productListingURL}${queryParams}`)
            .then(handleResponse)
            .catch(handleError);
        return data;
    }
}

export default ProductListing;